export function normalizeCustomTexts(customTexts) {
  if (!customTexts) return {};

  if (typeof customTexts === 'string') {
    try {
      customTexts = JSON.parse(customTexts);
    } catch (error) {
      return {};
    }
  }

  if (typeof customTexts !== 'object' || Array.isArray(customTexts)) {
    return {};
  }

  return Object.entries(customTexts).reduce((result, [key, value]) => {
    if (typeof key === 'string' && typeof value === 'string' && key.trim() && value.trim()) {
      result[key.trim()] = value.trim();
    }
    return result;
  }, {});
}

export function getCustomText(customTexts, id, fallback, variables = {}) {
  const normalizedTexts = normalizeCustomTexts(customTexts);
  const rawText = normalizedTexts[id] || fallback || '';

  return rawText.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (match, key) => {
    if (Object.prototype.hasOwnProperty.call(variables, key)) {
      const value = variables[key];
      return value == null ? '' : String(value);
    }

    return '';
  });
}
